<script setup>
import { useTheme } from "vuetify";

const model = defineModel({ type: Object });

const style = ref("");
const theme = useTheme();

function updateTheme() {
  if (model.value) {
    if (model.value.main_color) {
      theme.themes.value.light.colors.primary = model.value.main_color;
    }
    if (model.value.button_color) {
      theme.themes.value.light.colors.secondary = model.value.button_color;
    }
    if (model.value.bg_url) {
      style.value = `main::before {
              content:"";
              position:absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image:url('${model.value.bg_url}');
              background-position: center top;
              background-repeat: repeat;
            }`;
    }
  }
}

watch(model, updateTheme, { immediate: true });
</script>
<template>
  <component :is="`style`" v-html="style"></component>
</template>
